<p-toast position="top-right"></p-toast>

<div *ngIf="form" class="flex flex-col" [formGroup]="form">
    <!-- HEADER sticky -->
    <div class="card mb-3 anf-sticky-header">
        <div class="flex flex-wrap items-center justify-between gap-3">
            <div>
                <div class="font-semibold text-xl leading-tight">{{ title }}</div>
                <div class="text-sm text-gray-500">{{ listLabel }}</div>
            </div>
            <div class="flex items-center gap-2">
                <button pButton type="button" label="Annulla" severity="secondary" [outlined]="true" (click)="annulla()"></button>
                <button *ngIf="!isReadonly" pButton type="button" icon="pi pi-save" label="Salva" class="p-button-success" [disabled]="saving" (click)="salva()"></button>
            </div>
        </div>
    </div>

    <!-- CONTENUTO -->
    <div class="card">
        <!-- DATI AZIENDA -->
        <section class="anf-section">
            <div class="anf-section-title">Dati azienda</div>
            <div class="anf-grid">
                <div class="anf-field">
                    <label for="ragioneSociale">Ragione sociale <span class="req">*</span></label>
                    <input pInputText id="ragioneSociale" formControlName="ragioneSociale" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field">
                    <label for="partitaIva">Partita IVA</label>
                    <input pInputText id="partitaIva" formControlName="partitaIva" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field">
                    <label for="codiceFiscale">Codice fiscale</label>
                    <input pInputText id="codiceFiscale" formControlName="codiceFiscale" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field">
                    <label for="paese">Paese</label>
                    <p-select inputId="paese" [options]="countries" formControlName="paese" optionLabel="name" optionValue="code" [filter]="true" [showClear]="true" [disabled]="isReadonly" appendTo="body" placeholder="Seleziona" styleClass="w-full"></p-select>
                </div>
                <div class="anf-field">
                    <label for="telefonoAzienda">Telefono</label>
                    <input pInputText id="telefonoAzienda" formControlName="telefonoAzienda" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field">
                    <label for="email">Email</label>
                    <input pInputText id="email" formControlName="email" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field" *ngIf="isCliente">
                    <label for="fax">Fax</label>
                    <input pInputText id="fax" formControlName="fax" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field" *ngIf="isCliente">
                    <label for="sitoWeb">Sito web</label>
                    <input pInputText id="sitoWeb" formControlName="sitoWeb" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field anf-check" *ngIf="!isCliente">
                    <p-checkbox inputId="flgAttivo" binary="true" formControlName="flgAttivo"></p-checkbox>
                    <label for="flgAttivo">Attivo</label>
                </div>
            </div>
        </section>

        <!-- INDIRIZZO -->
        <section class="anf-section">
            <div class="anf-section-title">Indirizzo</div>
            <div class="anf-grid">
                <div class="anf-field">
                    <label for="indirizzo">Indirizzo</label>
                    <input pInputText id="indirizzo" formControlName="indirizzo" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field">
                    <label for="cap">CAP</label>
                    <input pInputText id="cap" formControlName="cap" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field">
                    <label for="localita">Località</label>
                    <input pInputText id="localita" formControlName="localita" [readonly]="isReadonly" class="w-full" />
                </div>
            </div>
        </section>

        <!-- REFERENTE -->
        <section class="anf-section">
            <div class="anf-section-title">Referente</div>
            <div class="anf-grid">
                <div class="anf-field">
                    <label for="nome">Nome</label>
                    <input pInputText id="nome" formControlName="nome" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field">
                    <label for="cognome">Cognome</label>
                    <input pInputText id="cognome" formControlName="cognome" [readonly]="isReadonly" class="w-full" />
                </div>
                <div class="anf-field">
                    <label for="cellulare">Cellulare</label>
                    <input pInputText id="cellulare" formControlName="cellulare" [readonly]="isReadonly" class="w-full" />
                </div>
            </div>
        </section>

        <!-- NOTE -->
        <section class="anf-section">
            <div class="anf-section-title">Note</div>
            <textarea rows="4" pTextarea formControlName="note" class="w-full" [readonly]="isReadonly"></textarea>
        </section>
    </div>
</div>
